import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import SendIcon from '@mui/icons-material/Send';
import AddCommentIcon from '@mui/icons-material/AddComment';
import '@/styles/MessageForm.css';
import { handleKeyDown, handleSubmitMessage, resetTextareaHeight } from '@/utils/index';
/**
 * MessageForm component.
 *
 * This component represents the form for sending messages. It includes a textarea for inputting messages,
 * a button to start a new chat, and a button to submit the message.
 *
 * @param {MessageFormProps} props - The props for the component.
 * @returns {JSX.Element} The MessageForm component.
 */
const MessageForm = ({ inputMessage, setInputMessage, handleSendMessage, selectedConversationId, startNewChat, }) => {
    const textareaRef = useRef(null);
    return (_jsxs("form", Object.assign({ className: "message-form", onSubmit: (e) => handleSubmitMessage(e, handleSendMessage, () => resetTextareaHeight(textareaRef)) }, { children: [_jsxs("button", Object.assign({ type: "button", className: "new-chat-button", onClick: startNewChat, title: "Start a new chat" }, { children: [_jsx(AddCommentIcon, {}), " NEW CHAT"] })), _jsx("textarea", { ref: textareaRef, className: "message-input", placeholder: "Message the H&M Learning Chatbot", value: inputMessage, onChange: e => setInputMessage(e.target.value), onKeyDown: (e) => handleKeyDown(e, handleSendMessage, () => resetTextareaHeight(textareaRef)), onInput: e => {
                    const target = e.target;
                    target.style.height = 'auto';
                    target.style.height = `${target.scrollHeight}px`;
                }, rows: 1 }), _jsx("button", Object.assign({ type: "submit", className: "submit-button", title: "Submit chat message" }, { children: _jsx(SendIcon, {}) }))] })));
};
export default MessageForm;
